import React, { useEffect, useState } from 'react';
import api from '../../services/apiPowerBI';

import { Container, Tabs, Tab } from 'react-bootstrap';
import Navbar from '../../components/navbar';
import Icone from '../../components/Icone';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Visao() {
    const [erro, setErro] = useState();
    const [relatorios, setRelatorios] = useState(true);
    const [carregando, setCarregando] = useState(true);


    useEffect(() => {
        GetDados();
        //eslint-disable-next-line
    }, [])


    function GetDados() {
        carregando ?? setCarregando(true)

        api.get(`/Relatorios/v2/ListaRelPowerBI`,{
            params: {
                USUARIO: sessionStorage.getItem('RC_USR_PORTAL'),
                ALIAS: window.novo_alias_RC
            },
        })
            .then(resp => setRelatorios(resp.data))
            .catch(err => setErro(err.toString()))
            .finally(() => setCarregando(false));
    }

    return (
        <>
            <Navbar />

            <Container fluid className="container-card bg-white">
                {erro &&
                    <div className="alert alert-danger" role="alert">
                        <Icone icon="times" customClass='mr-2' />
                        {erro}
                    </div>}



                {carregando ?
                    <p>Carregando</p>
                    :
                    <Tabs defaultActiveKey="1" id="tab-powerbi" className='pt-3'>
                        {relatorios.map((item) => (
                            <Tab eventKey={item.sequencial} title={item.nomerelatorio}>
                                <Link to={'/kpi'} onClick={() => {
                                    window.open(
                                        item.linkrelatorio,
                                        "_blank",
                                        "width=1080,height=700,resizable=yes"
                                    )
                                }} className="link-card">

                                    <div className="item-card shadow">
                                        <FontAwesomeIcon className="icon-menu" icon={'chart-pie'} />
                                        <p><strong>Abrir Relatório</strong></p>

                                        <h2>{item.nomerelatorio}</h2>

                                    </div>
                                </Link>
                                {/* <iframe
                                            title={item.nomerelatorio}
                                            width="100vw" height={"100vh"}
                                            style={{
                                                top: 0,
                                                width: "100%",
                                                marginTop: '10px',
                                                height: "calc(100vh - 110px)",
                                            }}
                                            scrolling={'no'}
                                            src={item.linkrelatorio}
                                            frameBorder={0}
                                            allowFullScreen={true}>
                                        </iframe> */}
                            </Tab>
                        ))}
                    </Tabs>
                }
            </Container>
        </>
    );
}
